import {numberWithNounEn, numberWithNounRu} from '../lang-util'

export const feedbackEn = {
  menu: 'Support / News',
  support: 'Support',
  supportDescr: 'Ask your question to our support team. We respond quickly.',
  news: 'News',
  newsDescr: 'Inside the news is a public discussion. Join the discussion!',
  openRequests: 'Open requests',
  closedRequests: 'Closed requests',
  inputTopic: 'Topic',
  inputMessage: 'Message',
  noTopicWarn: 'Please, specify a topic',
  noTextWarn: 'Please, write the text of your request',
  ticketAddSuccess: 'Request added successfully',
  attach: 'Attach file',
  comments: numberWithNounEn({
    one: 'comment',
    other: 'comments'
  }),
  allUpdates: 'All updates',
  updateFrom: 'Update from',
  leaveComment: 'Leave a comment'
}

export const feedbackRu: typeof feedbackEn = {
  menu: 'Тех. поддержка / Новости',
  support: 'Тех. поддержка',
  supportDescr: 'Задайте свой вопрос в нашу службу поддержки. Отвечаем быстро.',
  news: 'Новости компании',
  newsDescr:
    'Внутри новости — публичное обсуждение. Присоединяйтесь к обсуждению!',
  openRequests: 'Актуальные обращения',
  closedRequests: 'Закрытые обращения',
  inputTopic: 'Тема обращения',
  inputMessage: 'Текст обращения',
  noTopicWarn: 'Укажите тему обращения',
  noTextWarn: 'Напишите текст обращения',
  ticketAddSuccess: 'Обращение добавлено',
  attach: 'Прикрепить файл',
  comments: numberWithNounRu({
    one: 'комментарий',
    few: 'комментария',
    many: 'комментариев'
  }),
  allUpdates: 'Все обновления',
  updateFrom: 'Обновление от',
  leaveComment: 'Оставьте комментарий'
}
